// extracted by mini-css-extract-plugin
export default {"header":"HeaderItem_header__JNe8o","user":"HeaderItem_user__7zyM0","label":"HeaderItem_label__TEY5X"};